import { icon_arrow_right } from '@gn-audio/icons';

import { Button } from '../../Button/Button';
import { JabraFocusItem } from '../../JabraFocus';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { ScopedStyle } from '../../ScopedStyle/ScopedStyle';
import { CampaignCard } from '../megaMenuTypes';
import { getBgBasedColor, getRandomBGColor } from '../megaMenuUtils';
import { BackgroundImage } from './BackgroundImage';

import styles from './Cards.module.css';

export const Campaigns = ({ items }: { items: CampaignCard[] }): React.JSX.Element => {
  const bgColors = items.map((item) => getRandomBGColor(item.id));
  return (
    <div>
      {items.map((card, index) => {
        const bgColor = card.BackgroundImage?.value?.src ? 'big-photo' : bgColors[index];
        const textColor = getBgBasedColor(bgColor);

        return card.Link ? (
          <ScopedStyle
            id={card.id}
            css={card.Style?.value ?? ''}
            renderItem={(styleLinkingProp) => (
              <JabraFocusItem key={card.id} asChild>
                <a
                  href={card.Link?.value?.href}
                  className={`group relative hover:no-underline ${styles.card} ${bgColor} ${textColor}`}
                  {...styleLinkingProp}
                >
                  {card.BackgroundImage?.value?.src ? (
                    <BackgroundImage
                      field={card.BackgroundImage}
                      externalField={{
                        altText: card.Header?.value || 'Campaign Image',
                      }}
                      cardType="big"
                    />
                  ) : null}
                  <div className="z-10 flex-col">
                    <p className={styles.header}>{card.Header?.value}</p>
                    <p className={styles.description}>{card.Description?.value}</p>
                    <p className={styles.footer}>{card.Footer?.value}</p>
                  </div>
                  <Button
                    variant="primary"
                    size="m"
                    icon={<JabraIcon className="size-5" Icon={icon_arrow_right} />}
                    noKeyboard
                  />
                </a>
              </JabraFocusItem>
            )}
          />
        ) : null;
      })}
    </div>
  );
};
